import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import {
  Box,
  IconButton,
  Paper,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { Label } from "src/components";

const RootStyle = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
  boxShadow: theme.customShadows?.z8 || "0 8px 20px rgba(0,0,0,0.08)",
}));

export default function LocationCard({
  item,
  row,
  isLoading,
  serialNumber,
  retrieveValue,
}) {
  const theme = useTheme();
  const data = item || row || {};
  const isActive = data?.is_active === true || data?.is_active === 1;

  return (
    <RootStyle
      sx={{
        borderLeft: `6px solid ${
          isLoading
            ? theme.palette.divider
            : theme.palette[isActive ? "success" : "error"].main
        }`,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 42,
            height: 42,
            flexShrink: 0,
            borderRadius: 1.5,
            display: "grid",
            placeItems: "center",
            bgcolor: (theme) => theme.palette.action.hover,
            color: "text.secondary",
          }}
        >
          {isLoading ? (
            <Skeleton variant="rounded" width={42} height={42} />
          ) : (
            <LocationCityIcon fontSize="small" />
          )}
        </Box>

        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {isLoading ? <Skeleton width={32} /> : `#${serialNumber}`}
          </Typography>
          <Typography variant="subtitle1" fontWeight={700} noWrap>
            {isLoading ? <Skeleton width="70%" /> : data?.name || "Untitled"}
          </Typography>
          <Box sx={{ mt: 1 }}>
            {isLoading ? (
              <Skeleton width={64} height={24} />
            ) : (
              <Label
                variant={theme.palette.mode === "light" ? "ghost" : "filled"}
                color={isActive ? "success" : "error"}
              >
                {isActive ? "Active" : "in-active"}
              </Label>
            )}
          </Box>
        </Box>

        {isLoading ? (
          <Skeleton variant="circular" width={34} height={34} />
        ) : (
          <Tooltip title="Edit">
            <IconButton
              size="small"
              onClick={() => retrieveValue?.(data)}
              disabled={!data?._id}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </RootStyle>
  );
}
